export default __webpack_public_path__ + "static/media/game-cabinet.1e194dc0.png";